import { EFaceType } from '@/editor/entities/type';
import { IPoint2d } from '@/editor/math/IPoint2d';
import { IMaterialInfo } from '../material/material';
import { EFaceSide } from '@/editor/types';
import { ESeparateWallType } from '../separateWall/SeparateWall';
import { IShapePoint2d } from '@/editor/types/shape';

export enum EWallFaceLayout {
  ALL = 1,
  DOWN = 2,
  UP = 3,
  MIDDLE = 4
}

export interface IBaseDataEdgeFace {
  start: IPoint2d;
  end: IPoint2d;
  height: number;
  offGround: number;
}
export interface IBaseDataArcEdgeFace {
  start: IPoint2d;
  end: IPoint2d;
  height: number;
  offGround: number;
  center: IPoint2d;
  clockwise: boolean;
}

export interface IBaseDataHoleFace {
  center: IPoint2d;
  width: number;
  height: number;
  thickness: number;
  offGround: number;
  rotation: number;
  arcCenter?: IPoint2d;
}

export interface IBaseDataContourFace {
  contour: IShapePoint2d[];
  offGround: number;
}

export interface IBaseDataCylinderFace {
  center: IPoint2d;
  radius: number;
  offGround: number;
  height: number;
}

export enum EFaceDataBaseType {
  Edge = 1,
  Contour = 2,
  Hole = 3,
  Cylinder = 4,
  ArcEdge = 5
}

export type IFaceData = IFaceDataBase & IFaceDataExtra;

/** 墙面挂在哪个构件的哪一侧。face 的认领(getWallFaceRelativeMap 等)全靠它 */
export interface IFaceRelativeInfo {
  wallId?: string;
  side?: EFaceSide;
  columnId?: string;
  columnSide?: EFaceSide;
  sepId?: string;
  sepSide?: EFaceSide;
  sepType?: ESeparateWallType;
  startId?: number;
  endId?: number;
  layout?: EWallFaceLayout;
  dwId?: string; // 门窗id
  regionId?: string;
}

export interface IFaceDataBase {
  id: string;
  type: EFaceType;
  baseDataType: EFaceDataBaseType;
  materialInfo: IMaterialInfo;
  /** 创建时的关联信息。BaseFaceStore 一直存在 base 表里(只有它进 history)，之前漏在类型上声明 */
  relativeInfo: IFaceRelativeInfo;
}

/** 墙面洞口顶点。x 方向存的是比例(距 face 起点的距离/墙面长度)，y 是绝对高度 */
export interface IFaceHolePoint {
  ratioX: number;
  y: number;
}

export interface IFaceDataExtra {
  holes: IFaceHolePoint[][];
  baseData: IBaseDataEdgeFace | IBaseDataContourFace | IBaseDataHoleFace | IBaseDataCylinderFace | IBaseDataArcEdgeFace;
  /**
   * 每次 refreshFaceDatas 重算出来的关联信息，会盖掉 base 里创建时那份(拓扑一变 startId/endId 就变)。
   * 可选：add 时不写，此时 IFaceData 上取到的是 base 里的那份。
   */
  relativeInfo?: IFaceRelativeInfo;
}
